
import trees from "./zTree/src";
import {Modal,Modals,Dialog} from './Modal'
import Pagination from '@/components/Pagination'
import mergeTable from '@/components/MergeTable'

/** brian 2022 02 07 */
import Search from './search/Search.vue';
import Button from './button/Button.vue';
/**
 * 注册全局组件
 */
export default (Vue) => {
   Vue.component('trees',trees);
   Vue.component('Modal',Modal);
   Vue.component('Modals',Modals);
   Vue.component('Dialog',Dialog);
   Vue.component('Pagination',Pagination);
   Vue.component('mergeTable',mergeTable);
   Vue.component('v-search',Search);
   Vue.component('v-button',Button);
}
